// Module
var code = `<div class="js-trading-password-main">
    <div class="js-trading-password">
        <div class="trading-password-header">
            <div class="imageTradePassword">
                <svg>
                    <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#tabStripItemLocked"></use>
                </svg>
            </div>
            <terceraLabel additionalClass="js-label-header" text="{{.textPasswordLabel}}"/>
        </div>
        <div class="trading-password-container">
            <passwordTextBox 
                    elementStyle="js-input-container-login" 
                    placeholder="{{.placeholderPassword}}" 
                    text="{{.tradePass}}" 
                    haveError="{{.visibilityError}}"
                    name="tbPwd" 
                    showPasswordPreview="{{.allowPreviewPassword}}" 
                    isMaterialDesign="false"/>
            <terceraLabel 
                    additionalClass="js-tercera-label-error" 
                    text="{{.textErrorLabel}}" 
                    visible="{{.visibilityError}}"/>
        </div>
    </div>
  <terceraButton text="{{.textButton}}" terceraButtonStyle="js-button-ok" on-componentClick="UnlockClick"/>
</div>`;
// Exports
export default code;